export interface GlobalTheme {
  id: string;
  name: string;
  shortName: string;
  tag: string;
  description: string;
  badgeBg: string;
  primaryColor: string;
  accentGradient: string;
  cardGradients: string[];
  activeRing: string;
  capsule: string;
  capsuleSub: string;
  classBadge: string;
  topicPill: string;
  subjectColor: string;
  btnGrading: string;
  btnAttendance: string;
  statusSelect: string;
  statusSelectIcon: string;
  breakCard: string;
  breakIcon: string;
  sidebarBgLight?: string;
  sidebarBgDark?: string;
  headerBgLight?: string;
  headerBgDark?: string;
  appBgLight?: string;
  appBgDark?: string;
  primaryButton?: string;
  activeNavGradient?: string;
  sidebarActive?: string;
}

export const APP_THEMES: GlobalTheme[] = [
  {
    id: 'wzc-themes',
    name: "wzc'themes (Default)",
    shortName: "wzc'themes",
    tag: 'Tema 1 (Default)',
    description: 'Tema standar modern bersih dengan aksen solid gradient elegan & kontras tinggi',
    badgeBg: 'bg-indigo-600 text-white',
    primaryColor: '#4f46e5',
    accentGradient: 'from-indigo-600 via-purple-600 to-pink-600',
    activeNavGradient: 'from-indigo-600 via-indigo-500 to-violet-600',
    sidebarActive: 'bg-indigo-600 text-white',
    primaryButton: 'bg-indigo-600 hover:bg-indigo-700 text-white',
    cardGradients: [
      'bg-gradient-to-r from-indigo-600 via-indigo-700 to-blue-700 border-indigo-400/40 text-white shadow-lg shadow-indigo-950/20',
      'bg-gradient-to-r from-emerald-600 via-teal-700 to-emerald-800 border-emerald-400/40 text-white shadow-lg shadow-emerald-950/20',
      'bg-gradient-to-r from-rose-600 via-pink-600 to-rose-700 border-rose-400/40 text-white shadow-lg shadow-rose-950/20',
      'bg-gradient-to-r from-amber-500 via-orange-600 to-amber-600 border-amber-300/40 text-white shadow-lg shadow-amber-950/20',
      'bg-gradient-to-r from-violet-600 via-purple-700 to-indigo-700 border-violet-400/40 text-white shadow-lg shadow-violet-950/20',
      'bg-gradient-to-r from-cyan-600 via-sky-600 to-blue-700 border-cyan-400/40 text-white shadow-lg shadow-cyan-950/20',
      'bg-gradient-to-r from-fuchsia-600 via-pink-700 to-rose-700 border-fuchsia-400/40 text-white shadow-lg shadow-fuchsia-950/20',
    ],
    activeRing: 'ring-4 ring-amber-300 shadow-2xl scale-[1.01]',
    capsule: 'bg-white/20 backdrop-blur-md text-white border border-white/30 shadow-inner',
    capsuleSub: 'text-white/80',
    classBadge: 'bg-white/25 backdrop-blur-sm text-white border border-white/30 font-bold',
    topicPill: 'bg-black/20 text-white/95 border border-white/15',
    subjectColor: 'text-white font-black',
    btnGrading: 'bg-white text-emerald-700 hover:bg-emerald-50 shadow-md font-black',
    btnAttendance: 'bg-white text-indigo-700 hover:bg-indigo-50 shadow-md font-black',
    statusSelect: 'bg-white/25 text-white border border-white/40 font-black backdrop-blur-sm',
    statusSelectIcon: 'text-white',
    breakCard: 'bg-gradient-to-r from-emerald-800 via-teal-700 to-emerald-900 border-emerald-400/50 text-white shadow-lg',
    breakIcon: 'bg-white/20 text-white border border-white/30',
    sidebarBgLight: 'bg-white',
    sidebarBgDark: 'bg-black',
    headerBgLight: 'bg-white',
    headerBgDark: 'bg-slate-900',
    appBgLight: 'bg-slate-50',
    appBgDark: 'bg-slate-950',
  },
  {
    id: 'midnight-velvet',
    name: 'Midnight Velvet',
    shortName: 'Midnight Velvet',
    tag: 'Tema 2',
    description: 'Nuansa gelap mewah obsidian dengan sentuhan neon violet dan royal navy',
    badgeBg: 'bg-purple-900 text-purple-200 border border-purple-500/50',
    primaryColor: '#9333ea',
    accentGradient: 'from-purple-900 via-indigo-900 to-slate-950',
    activeNavGradient: 'from-purple-700 via-indigo-600 to-violet-800',
    sidebarActive: 'bg-gradient-to-r from-purple-700 to-indigo-700 text-white border border-purple-400/30',
    primaryButton: 'bg-purple-700 hover:bg-purple-800 text-white',
    cardGradients: [
      'bg-gradient-to-r from-slate-950 via-indigo-950 to-purple-950 border-purple-500/40 text-white shadow-lg shadow-purple-950/40',
      'bg-gradient-to-r from-slate-950 via-emerald-950 to-teal-950 border-emerald-500/40 text-white shadow-lg shadow-emerald-950/40',
      'bg-gradient-to-r from-slate-950 via-rose-950 to-pink-950 border-rose-500/40 text-white shadow-lg shadow-rose-950/40',
      'bg-gradient-to-r from-slate-950 via-amber-950 to-orange-950 border-amber-500/40 text-white shadow-lg shadow-amber-950/40',
      'bg-gradient-to-r from-slate-950 via-purple-950 to-slate-900 border-purple-500/40 text-white shadow-lg shadow-purple-950/40',
      'bg-gradient-to-r from-slate-950 via-cyan-950 to-blue-950 border-cyan-500/40 text-white shadow-lg shadow-cyan-950/40',
      'bg-gradient-to-r from-slate-950 via-fuchsia-950 to-purple-950 border-fuchsia-500/40 text-white shadow-lg shadow-fuchsia-950/40',
    ],
    activeRing: 'ring-2 ring-purple-400 shadow-purple-500/40 scale-[1.01]',
    capsule: 'bg-slate-900/90 text-purple-300 border border-purple-500/40 shadow-inner',
    capsuleSub: 'text-purple-400',
    classBadge: 'bg-purple-500/20 text-purple-200 border border-purple-500/40 font-bold',
    topicPill: 'bg-slate-900/80 text-purple-100 border border-purple-700/50',
    subjectColor: 'text-white font-black',
    btnGrading: 'bg-emerald-700 hover:bg-emerald-600 text-white shadow-md font-black border border-emerald-400/30',
    btnAttendance: 'bg-purple-700 hover:bg-purple-600 text-white shadow-md font-black border border-purple-400/30',
    statusSelect: 'bg-slate-900/90 text-purple-200 border border-purple-700/60 font-bold',
    statusSelectIcon: 'text-purple-300',
    breakCard: 'bg-gradient-to-r from-slate-950 via-teal-950 to-slate-900 border-emerald-500/40 text-white shadow-lg',
    breakIcon: 'bg-emerald-950/90 text-emerald-300 border border-emerald-500/40',
    sidebarBgLight: 'bg-slate-900 text-slate-100',
    sidebarBgDark: 'bg-slate-950 text-purple-100',
    headerBgLight: 'bg-slate-900 text-white',
    headerBgDark: 'bg-slate-950 text-white',
    appBgLight: 'bg-slate-950',
    appBgDark: 'bg-black',
  },
  {
    id: 'sunset-flame',
    name: 'Sunset Flame',
    shortName: 'Sunset Flame',
    tag: 'Tema 3',
    description: 'Spektrum hangat fajar & senja dengan gradasi merah rubi, amber emas, dan jingga',
    badgeBg: 'bg-rose-600 text-white',
    primaryColor: '#e11d48',
    accentGradient: 'from-rose-600 via-orange-600 to-amber-500',
    activeNavGradient: 'from-rose-600 via-pink-600 to-orange-500',
    sidebarActive: 'bg-gradient-to-r from-rose-600 to-orange-500 text-white',
    primaryButton: 'bg-rose-600 hover:bg-rose-700 text-white',
    cardGradients: [
      'bg-gradient-to-r from-rose-600 via-pink-600 to-orange-500 border-rose-400/40 text-white shadow-lg shadow-rose-950/20',
      'bg-gradient-to-r from-purple-700 via-fuchsia-600 to-pink-600 border-fuchsia-400/40 text-white shadow-lg shadow-fuchsia-950/20',
      'bg-gradient-to-r from-orange-600 via-amber-600 to-yellow-500 border-amber-300/40 text-white shadow-lg shadow-amber-950/20',
      'bg-gradient-to-r from-teal-600 via-emerald-600 to-cyan-600 border-teal-400/40 text-white shadow-lg shadow-teal-950/20',
      'bg-gradient-to-r from-indigo-700 via-violet-600 to-pink-600 border-indigo-400/40 text-white shadow-lg shadow-indigo-950/20',
      'bg-gradient-to-r from-red-600 via-rose-700 to-orange-600 border-red-400/40 text-white shadow-lg shadow-red-950/20',
      'bg-gradient-to-r from-amber-600 via-rose-600 to-purple-700 border-pink-400/40 text-white shadow-lg shadow-purple-950/20',
    ],
    activeRing: 'ring-4 ring-yellow-300 shadow-2xl scale-[1.01]',
    capsule: 'bg-white/20 backdrop-blur-md text-white border border-white/30 shadow-inner',
    capsuleSub: 'text-white/80',
    classBadge: 'bg-white/25 backdrop-blur-sm text-white border border-white/30 font-bold',
    topicPill: 'bg-black/20 text-white/95 border border-white/15',
    subjectColor: 'text-white font-black',
    btnGrading: 'bg-white text-rose-700 hover:bg-rose-50 shadow-md font-black',
    btnAttendance: 'bg-white text-purple-700 hover:bg-purple-50 shadow-md font-black',
    statusSelect: 'bg-white/25 text-white border border-white/40 font-black backdrop-blur-sm',
    statusSelectIcon: 'text-white',
    breakCard: 'bg-gradient-to-r from-amber-700 via-orange-700 to-emerald-800 border-amber-300/50 text-white shadow-lg',
    breakIcon: 'bg-white/20 text-white border border-white/30',
    sidebarBgLight: 'bg-rose-50/50',
    sidebarBgDark: 'bg-slate-950',
    headerBgLight: 'bg-white',
    headerBgDark: 'bg-slate-900',
    appBgLight: 'bg-orange-50/30',
    appBgDark: 'bg-slate-950',
  },
  {
    id: 'cyber-neon',
    name: 'Cyber Neon',
    shortName: 'Cyber Neon',
    tag: 'Tema 4',
    description: 'Estetika futuristik berteknologi tinggi dengan garis luminesen cyan, emerald & magenta',
    badgeBg: 'bg-cyan-500 text-slate-950 font-black',
    primaryColor: '#06b6d4',
    accentGradient: 'from-cyan-500 via-blue-600 to-fuchsia-600',
    activeNavGradient: 'from-cyan-500 via-sky-600 to-blue-700',
    sidebarActive: 'bg-cyan-500/20 text-cyan-300 border border-cyan-400 shadow-[0_0_15px_rgba(6,182,212,0.35)]',
    primaryButton: 'bg-cyan-500 hover:bg-cyan-600 text-slate-950 font-black shadow-[0_0_15px_rgba(6,182,212,0.4)]',
    cardGradients: [
      'bg-gradient-to-r from-slate-950 via-cyan-950 to-blue-950 border-cyan-400 text-cyan-50 shadow-[0_0_15px_rgba(6,182,212,0.25)]',
      'bg-gradient-to-r from-slate-950 via-emerald-950 to-teal-950 border-emerald-400 text-emerald-50 shadow-[0_0_15px_rgba(16,185,129,0.25)]',
      'bg-gradient-to-r from-slate-950 via-fuchsia-950 to-purple-950 border-fuchsia-400 text-fuchsia-50 shadow-[0_0_15px_rgba(217,70,239,0.25)]',
      'bg-gradient-to-r from-slate-950 via-amber-950 to-orange-950 border-amber-400 text-amber-50 shadow-[0_0_15px_rgba(245,158,11,0.25)]',
      'bg-gradient-to-r from-slate-950 via-blue-950 to-indigo-950 border-blue-400 text-blue-50 shadow-[0_0_15px_rgba(59,130,246,0.25)]',
      'bg-gradient-to-r from-slate-950 via-rose-950 to-red-950 border-rose-400 text-rose-50 shadow-[0_0_15px_rgba(244,63,94,0.25)]',
      'bg-gradient-to-r from-slate-950 via-violet-950 to-slate-900 border-violet-400 text-violet-50 shadow-[0_0_15px_rgba(139,92,246,0.25)]',
    ],
    activeRing: 'ring-2 ring-cyan-400 shadow-[0_0_25px_rgba(6,182,212,0.45)] scale-[1.01]',
    capsule: 'bg-black/70 text-cyan-300 border border-cyan-400/60 shadow-inner',
    capsuleSub: 'text-cyan-400',
    classBadge: 'bg-cyan-500/20 text-cyan-300 border border-cyan-400/60 font-mono font-bold',
    topicPill: 'bg-black/50 text-cyan-100 border border-cyan-500/30',
    subjectColor: 'text-white font-black tracking-wide',
    btnGrading: 'bg-emerald-500/20 text-emerald-200 hover:bg-emerald-500/30 border border-emerald-400/60 font-black backdrop-blur-md shadow-sm',
    btnAttendance: 'bg-cyan-500/20 text-cyan-200 hover:bg-cyan-500/30 border border-cyan-400/60 font-black backdrop-blur-md shadow-sm',
    statusSelect: 'bg-black/70 text-cyan-200 border border-cyan-400/50 font-bold',
    statusSelectIcon: 'text-cyan-400',
    breakCard: 'bg-gradient-to-r from-slate-950 via-teal-950 to-emerald-950 border-emerald-400 text-emerald-200 shadow-[0_0_15px_rgba(16,185,129,0.25)]',
    breakIcon: 'bg-emerald-950/80 text-emerald-300 border border-emerald-400/60',
    sidebarBgLight: 'bg-slate-950 text-cyan-200 border-cyan-900/40',
    sidebarBgDark: 'bg-black text-cyan-200 border-cyan-500/30',
    headerBgLight: 'bg-slate-950 text-cyan-200 border-cyan-900/40',
    headerBgDark: 'bg-black text-cyan-200 border-cyan-500/30',
    appBgLight: 'bg-slate-950',
    appBgDark: 'bg-black',
  },
  {
    id: 'emerald-forest',
    name: 'Emerald Forest',
    shortName: 'Emerald Forest',
    tag: 'Tema 5',
    description: 'Harmoni alam yang menenangkan dengan gradasi hijau zamrud, jade, toska, dan aksen emas',
    badgeBg: 'bg-emerald-600 text-white',
    primaryColor: '#059669',
    accentGradient: 'from-emerald-600 via-teal-600 to-cyan-600',
    activeNavGradient: 'from-emerald-600 via-teal-600 to-emerald-700',
    sidebarActive: 'bg-gradient-to-r from-emerald-600 to-teal-700 text-white',
    primaryButton: 'bg-emerald-600 hover:bg-emerald-700 text-white',
    cardGradients: [
      'bg-gradient-to-r from-emerald-700 via-teal-700 to-cyan-800 border-emerald-400/40 text-white shadow-lg shadow-emerald-950/20',
      'bg-gradient-to-r from-teal-700 via-emerald-800 to-green-800 border-teal-400/40 text-white shadow-lg shadow-teal-950/20',
      'bg-gradient-to-r from-cyan-700 via-blue-700 to-indigo-800 border-cyan-400/40 text-white shadow-lg shadow-cyan-950/20',
      'bg-gradient-to-r from-emerald-600 via-green-600 to-teal-700 border-green-300/40 text-white shadow-lg shadow-emerald-950/20',
      'bg-gradient-to-r from-teal-800 via-cyan-800 to-slate-900 border-teal-400/40 text-white shadow-lg shadow-teal-950/20',
      'bg-gradient-to-r from-emerald-800 via-teal-900 to-slate-950 border-emerald-500/40 text-white shadow-lg shadow-emerald-950/20',
      'bg-gradient-to-r from-green-700 via-teal-700 to-emerald-900 border-green-400/40 text-white shadow-lg shadow-green-950/20',
    ],
    activeRing: 'ring-4 ring-emerald-300 shadow-2xl scale-[1.01]',
    capsule: 'bg-white/20 backdrop-blur-md text-white border border-white/30 shadow-inner',
    capsuleSub: 'text-white/80',
    classBadge: 'bg-white/25 backdrop-blur-sm text-white border border-white/30 font-bold',
    topicPill: 'bg-black/20 text-white/95 border border-white/15',
    subjectColor: 'text-white font-black',
    btnGrading: 'bg-white text-emerald-800 hover:bg-emerald-50 shadow-md font-black',
    btnAttendance: 'bg-white text-teal-800 hover:bg-teal-50 shadow-md font-black',
    statusSelect: 'bg-white/25 text-white border border-white/40 font-black backdrop-blur-sm',
    statusSelectIcon: 'text-white',
    breakCard: 'bg-gradient-to-r from-emerald-900 via-teal-900 to-slate-950 border-emerald-400/50 text-white shadow-lg',
    breakIcon: 'bg-white/20 text-white border border-white/30',
    sidebarBgLight: 'bg-emerald-50/40',
    sidebarBgDark: 'bg-slate-950',
    headerBgLight: 'bg-white',
    headerBgDark: 'bg-slate-900',
    appBgLight: 'bg-emerald-50/20',
    appBgDark: 'bg-slate-950',
  },
  {
    id: 'ocean-deep',
    name: 'Ocean Deep',
    shortName: 'Ocean Deep',
    tag: 'Tema 6',
    description: 'Kedalaman samudra biru laut dengan aksen kobalt, akuamarin, dan gelombang safir',
    badgeBg: 'bg-sky-600 text-white',
    primaryColor: '#0284c7',
    accentGradient: 'from-sky-600 via-blue-600 to-indigo-700',
    activeNavGradient: 'from-sky-600 via-blue-600 to-indigo-600',
    sidebarActive: 'bg-gradient-to-r from-sky-600 to-blue-700 text-white',
    primaryButton: 'bg-sky-600 hover:bg-sky-700 text-white',
    cardGradients: [
      'bg-gradient-to-r from-sky-600 via-blue-700 to-indigo-800 border-sky-300/40 text-white shadow-lg shadow-sky-950/20',
      'bg-gradient-to-r from-blue-700 via-indigo-800 to-slate-900 border-blue-400/40 text-white shadow-lg shadow-blue-950/20',
      'bg-gradient-to-r from-cyan-600 via-teal-700 to-blue-800 border-cyan-300/40 text-white shadow-lg shadow-cyan-950/20',
      'bg-gradient-to-r from-indigo-600 via-blue-600 to-sky-700 border-indigo-300/40 text-white shadow-lg shadow-indigo-950/20',
      'bg-gradient-to-r from-sky-700 via-cyan-700 to-teal-800 border-sky-400/40 text-white shadow-lg shadow-sky-950/20',
      'bg-gradient-to-r from-blue-800 via-indigo-900 to-slate-950 border-blue-300/40 text-white shadow-lg shadow-blue-950/20',
      'bg-gradient-to-r from-teal-600 via-cyan-600 to-blue-700 border-teal-300/40 text-white shadow-lg shadow-teal-950/20',
    ],
    activeRing: 'ring-4 ring-sky-300 shadow-2xl scale-[1.01]',
    capsule: 'bg-white/20 backdrop-blur-md text-white border border-white/30 shadow-inner',
    capsuleSub: 'text-white/80',
    classBadge: 'bg-white/25 backdrop-blur-sm text-white border border-white/30 font-bold',
    topicPill: 'bg-black/20 text-white/95 border border-white/15',
    subjectColor: 'text-white font-black',
    btnGrading: 'bg-white text-sky-800 hover:bg-sky-50 shadow-md font-black',
    btnAttendance: 'bg-white text-blue-800 hover:bg-blue-50 shadow-md font-black',
    statusSelect: 'bg-white/25 text-white border border-white/40 font-black backdrop-blur-sm',
    statusSelectIcon: 'text-white',
    breakCard: 'bg-gradient-to-r from-sky-900 via-blue-950 to-slate-950 border-sky-400/50 text-white shadow-lg',
    breakIcon: 'bg-white/20 text-white border border-white/30',
    sidebarBgLight: 'bg-sky-50/40',
    sidebarBgDark: 'bg-slate-950',
    headerBgLight: 'bg-white',
    headerBgDark: 'bg-slate-900',
    appBgLight: 'bg-sky-50/20',
    appBgDark: 'bg-slate-950',
  },
  {
    id: 'sakura-blossom',
    name: 'Sakura Blossom',
    shortName: 'Sakura Blossom',
    tag: 'Tema 7',
    description: 'Kelembutan bunga sakura Jepang dengan palet merah muda pastel, rose gold & plum',
    badgeBg: 'bg-pink-600 text-white',
    primaryColor: '#db2777',
    accentGradient: 'from-pink-500 via-rose-500 to-purple-600',
    activeNavGradient: 'from-pink-500 via-rose-500 to-fuchsia-600',
    sidebarActive: 'bg-gradient-to-r from-pink-600 to-rose-600 text-white',
    primaryButton: 'bg-pink-600 hover:bg-pink-700 text-white',
    cardGradients: [
      'bg-gradient-to-r from-pink-600 via-rose-600 to-purple-700 border-pink-300/40 text-white shadow-lg shadow-pink-950/20',
      'bg-gradient-to-r from-rose-600 via-pink-700 to-red-700 border-rose-300/40 text-white shadow-lg shadow-rose-950/20',
      'bg-gradient-to-r from-fuchsia-600 via-pink-600 to-rose-600 border-fuchsia-300/40 text-white shadow-lg shadow-fuchsia-950/20',
      'bg-gradient-to-r from-purple-700 via-fuchsia-700 to-pink-700 border-purple-300/40 text-white shadow-lg shadow-purple-950/20',
      'bg-gradient-to-r from-pink-700 via-purple-800 to-indigo-800 border-pink-400/40 text-white shadow-lg shadow-pink-950/20',
      'bg-gradient-to-r from-rose-500 via-orange-500 to-pink-600 border-rose-300/40 text-white shadow-lg shadow-rose-950/20',
      'bg-gradient-to-r from-pink-600 via-fuchsia-700 to-purple-800 border-pink-300/40 text-white shadow-lg shadow-pink-950/20',
    ],
    activeRing: 'ring-4 ring-pink-300 shadow-2xl scale-[1.01]',
    capsule: 'bg-white/20 backdrop-blur-md text-white border border-white/30 shadow-inner',
    capsuleSub: 'text-white/80',
    classBadge: 'bg-white/25 backdrop-blur-sm text-white border border-white/30 font-bold',
    topicPill: 'bg-black/20 text-white/95 border border-white/15',
    subjectColor: 'text-white font-black',
    btnGrading: 'bg-white text-rose-700 hover:bg-rose-50 shadow-md font-black',
    btnAttendance: 'bg-white text-pink-700 hover:bg-pink-50 shadow-md font-black',
    statusSelect: 'bg-white/25 text-white border border-white/40 font-black backdrop-blur-sm',
    statusSelectIcon: 'text-white',
    breakCard: 'bg-gradient-to-r from-pink-900 via-rose-900 to-slate-950 border-pink-300/50 text-white shadow-lg',
    breakIcon: 'bg-white/20 text-white border border-white/30',
    sidebarBgLight: 'bg-pink-50/40',
    sidebarBgDark: 'bg-slate-950',
    headerBgLight: 'bg-white',
    headerBgDark: 'bg-slate-900',
    appBgLight: 'bg-pink-50/20',
    appBgDark: 'bg-slate-950',
  },
  {
    id: 'solar-aurora',
    name: 'Solar Aurora',
    shortName: 'Solar Aurora',
    tag: 'Tema 8',
    description: 'Cahaya spektakuler kutub utara memadukan hijau neon, toska elektrik, dan emas matahari',
    badgeBg: 'bg-lime-500 text-slate-950 font-black',
    primaryColor: '#84cc16',
    accentGradient: 'from-lime-500 via-emerald-500 to-teal-600',
    activeNavGradient: 'from-lime-600 via-emerald-600 to-teal-700',
    sidebarActive: 'bg-gradient-to-r from-lime-600 to-emerald-600 text-white',
    primaryButton: 'bg-lime-600 hover:bg-lime-700 text-white font-bold',
    cardGradients: [
      'bg-gradient-to-r from-emerald-600 via-lime-600 to-teal-700 border-lime-300/40 text-white shadow-lg shadow-emerald-950/20',
      'bg-gradient-to-r from-teal-600 via-cyan-600 to-emerald-700 border-cyan-300/40 text-white shadow-lg shadow-teal-950/20',
      'bg-gradient-to-r from-green-600 via-emerald-700 to-lime-700 border-green-300/40 text-white shadow-lg shadow-green-950/20',
      'bg-gradient-to-r from-lime-700 via-yellow-600 to-emerald-800 border-yellow-300/40 text-white shadow-lg shadow-lime-950/20',
      'bg-gradient-to-r from-teal-700 via-emerald-800 to-cyan-900 border-teal-300/40 text-white shadow-lg shadow-teal-950/20',
      'bg-gradient-to-r from-cyan-600 via-teal-600 to-green-700 border-cyan-300/40 text-white shadow-lg shadow-cyan-950/20',
      'bg-gradient-to-r from-emerald-700 via-green-800 to-teal-900 border-emerald-300/40 text-white shadow-lg shadow-emerald-950/20',
    ],
    activeRing: 'ring-4 ring-lime-300 shadow-2xl scale-[1.01]',
    capsule: 'bg-white/20 backdrop-blur-md text-white border border-white/30 shadow-inner',
    capsuleSub: 'text-white/80',
    classBadge: 'bg-white/25 backdrop-blur-sm text-white border border-white/30 font-bold',
    topicPill: 'bg-black/20 text-white/95 border border-white/15',
    subjectColor: 'text-white font-black',
    btnGrading: 'bg-white text-emerald-800 hover:bg-emerald-50 shadow-md font-black',
    btnAttendance: 'bg-white text-teal-800 hover:bg-teal-50 shadow-md font-black',
    statusSelect: 'bg-white/25 text-white border border-white/40 font-black backdrop-blur-sm',
    statusSelectIcon: 'text-white',
    breakCard: 'bg-gradient-to-r from-emerald-900 via-lime-950 to-teal-950 border-lime-400/50 text-white shadow-lg',
    breakIcon: 'bg-white/20 text-white border border-white/30',
    sidebarBgLight: 'bg-lime-50/40',
    sidebarBgDark: 'bg-slate-950',
    headerBgLight: 'bg-white',
    headerBgDark: 'bg-slate-900',
    appBgLight: 'bg-lime-50/20',
    appBgDark: 'bg-slate-950',
  },
  {
    id: 'royal-monarch',
    name: 'Royal Monarch',
    shortName: 'Royal Monarch',
    tag: 'Tema 9',
    description: 'Kemegahan kerajaan dengan warna ungu bangsawan, marun mahkota, dan aksen keemasan',
    badgeBg: 'bg-violet-700 text-white',
    primaryColor: '#6d28d9',
    accentGradient: 'from-violet-700 via-purple-700 to-indigo-800',
    activeNavGradient: 'from-violet-700 via-purple-600 to-indigo-700',
    sidebarActive: 'bg-gradient-to-r from-violet-700 to-purple-800 text-white',
    primaryButton: 'bg-violet-700 hover:bg-violet-800 text-white',
    cardGradients: [
      'bg-gradient-to-r from-violet-700 via-purple-700 to-indigo-800 border-violet-300/40 text-white shadow-lg shadow-violet-950/20',
      'bg-gradient-to-r from-purple-800 via-indigo-800 to-slate-900 border-purple-300/40 text-white shadow-lg shadow-purple-950/20',
      'bg-gradient-to-r from-indigo-700 via-violet-800 to-purple-900 border-indigo-300/40 text-white shadow-lg shadow-indigo-950/20',
      'bg-gradient-to-r from-fuchsia-700 via-purple-700 to-violet-800 border-fuchsia-300/40 text-white shadow-lg shadow-fuchsia-950/20',
      'bg-gradient-to-r from-violet-800 via-purple-900 to-black border-violet-400/40 text-white shadow-lg shadow-violet-950/20',
      'bg-gradient-to-r from-purple-700 via-pink-700 to-rose-800 border-purple-300/40 text-white shadow-lg shadow-purple-950/20',
      'bg-gradient-to-r from-indigo-800 via-violet-800 to-slate-900 border-indigo-300/40 text-white shadow-lg shadow-indigo-950/20',
    ],
    activeRing: 'ring-4 ring-amber-300 shadow-2xl scale-[1.01]',
    capsule: 'bg-white/20 backdrop-blur-md text-white border border-white/30 shadow-inner',
    capsuleSub: 'text-white/80',
    classBadge: 'bg-white/25 backdrop-blur-sm text-white border border-white/30 font-bold',
    topicPill: 'bg-black/20 text-white/95 border border-white/15',
    subjectColor: 'text-white font-black',
    btnGrading: 'bg-white text-emerald-800 hover:bg-emerald-50 shadow-md font-black',
    btnAttendance: 'bg-white text-violet-800 hover:bg-violet-50 shadow-md font-black',
    statusSelect: 'bg-white/25 text-white border border-white/40 font-black backdrop-blur-sm',
    statusSelectIcon: 'text-white',
    breakCard: 'bg-gradient-to-r from-purple-950 via-violet-950 to-indigo-950 border-amber-400/50 text-white shadow-lg',
    breakIcon: 'bg-white/20 text-white border border-white/30',
    sidebarBgLight: 'bg-violet-50/40',
    sidebarBgDark: 'bg-slate-950',
    headerBgLight: 'bg-white',
    headerBgDark: 'bg-slate-900',
    appBgLight: 'bg-violet-50/20',
    appBgDark: 'bg-slate-950',
  },
  {
    id: 'amber-honey',
    name: 'Amber Honey',
    shortName: 'Amber Honey',
    tag: 'Tema 10',
    description: 'Koleksi madu hangat, karamel mentega, tembaga keemasan, dan oranye kayu manis',
    badgeBg: 'bg-amber-600 text-white',
    primaryColor: '#d97706',
    accentGradient: 'from-amber-500 via-orange-500 to-yellow-600',
    activeNavGradient: 'from-amber-500 via-orange-600 to-yellow-600',
    sidebarActive: 'bg-gradient-to-r from-amber-600 to-orange-600 text-white',
    primaryButton: 'bg-amber-600 hover:bg-amber-700 text-white',
    cardGradients: [
      'bg-gradient-to-r from-amber-500 via-orange-600 to-yellow-600 border-amber-300/40 text-white shadow-lg shadow-amber-950/20',
      'bg-gradient-to-r from-orange-600 via-amber-700 to-red-700 border-orange-300/40 text-white shadow-lg shadow-orange-950/20',
      'bg-gradient-to-r from-yellow-600 via-amber-600 to-orange-700 border-yellow-200/40 text-white shadow-lg shadow-yellow-950/20',
      'bg-gradient-to-r from-amber-600 via-rose-600 to-orange-700 border-amber-300/40 text-white shadow-lg shadow-amber-950/20',
      'bg-gradient-to-r from-orange-700 via-red-800 to-amber-900 border-orange-300/40 text-white shadow-lg shadow-orange-950/20',
      'bg-gradient-to-r from-yellow-500 via-orange-500 to-amber-600 border-yellow-300/40 text-white shadow-lg shadow-yellow-950/20',
      'bg-gradient-to-r from-amber-700 via-orange-800 to-yellow-900 border-amber-400/40 text-white shadow-lg shadow-amber-950/20',
    ],
    activeRing: 'ring-4 ring-yellow-300 shadow-2xl scale-[1.01]',
    capsule: 'bg-white/20 backdrop-blur-md text-white border border-white/30 shadow-inner',
    capsuleSub: 'text-white/80',
    classBadge: 'bg-white/25 backdrop-blur-sm text-white border border-white/30 font-bold',
    topicPill: 'bg-black/20 text-white/95 border border-white/15',
    subjectColor: 'text-white font-black',
    btnGrading: 'bg-white text-emerald-800 hover:bg-emerald-50 shadow-md font-black',
    btnAttendance: 'bg-white text-amber-800 hover:bg-amber-50 shadow-md font-black',
    statusSelect: 'bg-white/25 text-white border border-white/40 font-black backdrop-blur-sm',
    statusSelectIcon: 'text-white',
    breakCard: 'bg-gradient-to-r from-amber-900 via-orange-950 to-slate-950 border-amber-300/50 text-white shadow-lg',
    breakIcon: 'bg-white/20 text-white border border-white/30',
    sidebarBgLight: 'bg-amber-50/40',
    sidebarBgDark: 'bg-slate-950',
    headerBgLight: 'bg-white',
    headerBgDark: 'bg-slate-900',
    appBgLight: 'bg-amber-50/20',
    appBgDark: 'bg-slate-950',
  },
  {
    id: 'nordic-frost',
    name: 'Nordic Frost',
    shortName: 'Nordic Frost',
    tag: 'Tema 11',
    description: 'Kesegaran es kutub Skandinavia dengan palet perak es, biru glasier, dan abu baja dingin',
    badgeBg: 'bg-slate-700 text-white',
    primaryColor: '#475569',
    accentGradient: 'from-slate-700 via-teal-700 to-cyan-800',
    activeNavGradient: 'from-slate-700 via-blue-800 to-cyan-800',
    sidebarActive: 'bg-gradient-to-r from-slate-700 to-teal-800 text-white',
    primaryButton: 'bg-slate-700 hover:bg-slate-800 text-white',
    cardGradients: [
      'bg-gradient-to-r from-slate-700 via-teal-700 to-cyan-800 border-slate-300/40 text-white shadow-lg shadow-slate-950/20',
      'bg-gradient-to-r from-cyan-700 via-slate-800 to-blue-900 border-cyan-300/40 text-white shadow-lg shadow-cyan-950/20',
      'bg-gradient-to-r from-teal-700 via-slate-700 to-emerald-800 border-teal-300/40 text-white shadow-lg shadow-teal-950/20',
      'bg-gradient-to-r from-blue-700 via-slate-800 to-slate-900 border-blue-300/40 text-white shadow-lg shadow-blue-950/20',
      'bg-gradient-to-r from-slate-800 via-cyan-900 to-slate-950 border-slate-300/40 text-white shadow-lg shadow-slate-950/20',
      'bg-gradient-to-r from-teal-800 via-slate-800 to-blue-950 border-teal-400/40 text-white shadow-lg shadow-teal-950/20',
      'bg-gradient-to-r from-slate-700 via-blue-700 to-teal-800 border-slate-300/40 text-white shadow-lg shadow-slate-950/20',
    ],
    activeRing: 'ring-4 ring-cyan-300 shadow-2xl scale-[1.01]',
    capsule: 'bg-white/20 backdrop-blur-md text-white border border-white/30 shadow-inner',
    capsuleSub: 'text-white/80',
    classBadge: 'bg-white/25 backdrop-blur-sm text-white border border-white/30 font-bold',
    topicPill: 'bg-black/20 text-white/95 border border-white/15',
    subjectColor: 'text-white font-black',
    btnGrading: 'bg-white text-emerald-800 hover:bg-emerald-50 shadow-md font-black',
    btnAttendance: 'bg-white text-slate-800 hover:bg-slate-50 shadow-md font-black',
    statusSelect: 'bg-white/25 text-white border border-white/40 font-black backdrop-blur-sm',
    statusSelectIcon: 'text-white',
    breakCard: 'bg-gradient-to-r from-slate-900 via-teal-950 to-slate-950 border-cyan-400/50 text-white shadow-lg',
    breakIcon: 'bg-white/20 text-white border border-white/30',
    sidebarBgLight: 'bg-slate-100/60',
    sidebarBgDark: 'bg-slate-950',
    headerBgLight: 'bg-white',
    headerBgDark: 'bg-slate-900',
    appBgLight: 'bg-slate-100/40',
    appBgDark: 'bg-slate-950',
  },
  {
    id: 'crimson-ruby',
    name: 'Crimson Ruby',
    shortName: 'Crimson Ruby',
    tag: 'Tema 12',
    description: 'Kemewahan batu permata delima merah membara dengan kilau karmin dan garnet',
    badgeBg: 'bg-red-700 text-white',
    primaryColor: '#b91c1c',
    accentGradient: 'from-red-600 via-rose-700 to-rose-900',
    activeNavGradient: 'from-red-600 via-rose-600 to-pink-700',
    sidebarActive: 'bg-gradient-to-r from-red-600 to-rose-700 text-white',
    primaryButton: 'bg-red-600 hover:bg-red-700 text-white',
    cardGradients: [
      'bg-gradient-to-r from-red-600 via-rose-700 to-pink-800 border-red-300/40 text-white shadow-lg shadow-red-950/20',
      'bg-gradient-to-r from-rose-700 via-red-800 to-orange-800 border-rose-300/40 text-white shadow-lg shadow-rose-950/20',
      'bg-gradient-to-r from-red-700 via-pink-700 to-purple-800 border-red-300/40 text-white shadow-lg shadow-red-950/20',
      'bg-gradient-to-r from-rose-600 via-orange-600 to-red-700 border-rose-300/40 text-white shadow-lg shadow-rose-950/20',
      'bg-gradient-to-r from-red-800 via-rose-900 to-slate-950 border-red-400/40 text-white shadow-lg shadow-red-950/20',
      'bg-gradient-to-r from-pink-700 via-rose-700 to-red-800 border-pink-300/40 text-white shadow-lg shadow-pink-950/20',
      'bg-gradient-to-r from-red-700 via-rose-800 to-purple-900 border-red-300/40 text-white shadow-lg shadow-red-950/20',
    ],
    activeRing: 'ring-4 ring-rose-300 shadow-2xl scale-[1.01]',
    capsule: 'bg-white/20 backdrop-blur-md text-white border border-white/30 shadow-inner',
    capsuleSub: 'text-white/80',
    classBadge: 'bg-white/25 backdrop-blur-sm text-white border border-white/30 font-bold',
    topicPill: 'bg-black/20 text-white/95 border border-white/15',
    subjectColor: 'text-white font-black',
    btnGrading: 'bg-white text-rose-800 hover:bg-rose-50 shadow-md font-black',
    btnAttendance: 'bg-white text-red-800 hover:bg-red-50 shadow-md font-black',
    statusSelect: 'bg-white/25 text-white border border-white/40 font-black backdrop-blur-sm',
    statusSelectIcon: 'text-white',
    breakCard: 'bg-gradient-to-r from-red-950 via-rose-950 to-slate-950 border-rose-400/50 text-white shadow-lg',
    breakIcon: 'bg-white/20 text-white border border-white/30',
    sidebarBgLight: 'bg-red-50/40',
    sidebarBgDark: 'bg-slate-950',
    headerBgLight: 'bg-white',
    headerBgDark: 'bg-slate-900',
    appBgLight: 'bg-red-50/20',
    appBgDark: 'bg-slate-950',
  },
  {
    id: 'matcha-zen',
    name: 'Matcha Zen',
    shortName: 'Matcha Zen',
    tag: 'Tema 13',
    description: 'Ketenangan teh hijau matcha Jepang, sage lembut, lumut zaitun, dan kebun zen',
    badgeBg: 'bg-lime-700 text-white',
    primaryColor: '#4d7c0f',
    accentGradient: 'from-lime-700 via-green-700 to-emerald-800',
    activeNavGradient: 'from-lime-700 via-green-600 to-teal-700',
    sidebarActive: 'bg-gradient-to-r from-lime-700 to-green-700 text-white',
    primaryButton: 'bg-lime-700 hover:bg-lime-800 text-white',
    cardGradients: [
      'bg-gradient-to-r from-lime-700 via-green-700 to-emerald-800 border-lime-300/40 text-white shadow-lg shadow-lime-950/20',
      'bg-gradient-to-r from-green-700 via-teal-700 to-emerald-800 border-green-300/40 text-white shadow-lg shadow-green-950/20',
      'bg-gradient-to-r from-emerald-700 via-green-800 to-lime-800 border-emerald-300/40 text-white shadow-lg shadow-emerald-950/20',
      'bg-gradient-to-r from-lime-600 via-yellow-600 to-green-700 border-lime-200/40 text-white shadow-lg shadow-lime-950/20',
      'bg-gradient-to-r from-green-800 via-emerald-900 to-slate-950 border-green-400/40 text-white shadow-lg shadow-green-950/20',
      'bg-gradient-to-r from-teal-700 via-green-700 to-lime-800 border-teal-300/40 text-white shadow-lg shadow-teal-950/20',
      'bg-gradient-to-r from-lime-800 via-emerald-800 to-teal-900 border-lime-300/40 text-white shadow-lg shadow-lime-950/20',
    ],
    activeRing: 'ring-4 ring-lime-300 shadow-2xl scale-[1.01]',
    capsule: 'bg-white/20 backdrop-blur-md text-white border border-white/30 shadow-inner',
    capsuleSub: 'text-white/80',
    classBadge: 'bg-white/25 backdrop-blur-sm text-white border border-white/30 font-bold',
    topicPill: 'bg-black/20 text-white/95 border border-white/15',
    subjectColor: 'text-white font-black',
    btnGrading: 'bg-white text-green-800 hover:bg-green-50 shadow-md font-black',
    btnAttendance: 'bg-white text-lime-800 hover:bg-lime-50 shadow-md font-black',
    statusSelect: 'bg-white/25 text-white border border-white/40 font-black backdrop-blur-sm',
    statusSelectIcon: 'text-white',
    breakCard: 'bg-gradient-to-r from-lime-950 via-green-950 to-slate-950 border-lime-400/50 text-white shadow-lg',
    breakIcon: 'bg-white/20 text-white border border-white/30',
    sidebarBgLight: 'bg-lime-50/40',
    sidebarBgDark: 'bg-slate-950',
    headerBgLight: 'bg-white',
    headerBgDark: 'bg-slate-900',
    appBgLight: 'bg-lime-50/20',
    appBgDark: 'bg-slate-950',
  },
  {
    id: 'cosmic-galaxy',
    name: 'Cosmic Galaxy',
    shortName: 'Cosmic Galaxy',
    tag: 'Tema 14',
    description: 'Eksplorasi antariksa galaksi dengan nebula ungu kosmik, biru bintang pulsar, dan stardust pink',
    badgeBg: 'bg-indigo-900 text-indigo-100 border border-indigo-400/40',
    primaryColor: '#6366f1',
    accentGradient: 'from-indigo-600 via-fuchsia-600 to-pink-600',
    activeNavGradient: 'from-indigo-600 via-purple-600 to-pink-600',
    sidebarActive: 'bg-gradient-to-r from-indigo-700 via-purple-700 to-pink-700 text-white',
    primaryButton: 'bg-indigo-600 hover:bg-indigo-700 text-white',
    cardGradients: [
      'bg-gradient-to-r from-slate-950 via-indigo-950 to-fuchsia-950 border-indigo-400/50 text-white shadow-lg shadow-indigo-950/30',
      'bg-gradient-to-r from-slate-950 via-purple-950 to-pink-950 border-purple-400/50 text-white shadow-lg shadow-purple-950/30',
      'bg-gradient-to-r from-slate-950 via-blue-950 to-indigo-950 border-blue-400/50 text-white shadow-lg shadow-blue-950/30',
      'bg-gradient-to-r from-slate-950 via-fuchsia-950 to-rose-950 border-fuchsia-400/50 text-white shadow-lg shadow-fuchsia-950/30',
      'bg-gradient-to-r from-slate-950 via-cyan-950 to-indigo-950 border-cyan-400/50 text-white shadow-lg shadow-cyan-950/30',
      'bg-gradient-to-r from-slate-950 via-violet-950 to-purple-950 border-violet-400/50 text-white shadow-lg shadow-violet-950/30',
      'bg-gradient-to-r from-slate-950 via-pink-950 to-indigo-950 border-pink-400/50 text-white shadow-lg shadow-pink-950/30',
    ],
    activeRing: 'ring-4 ring-fuchsia-300 shadow-2xl scale-[1.01]',
    capsule: 'bg-white/20 backdrop-blur-md text-white border border-white/30 shadow-inner',
    capsuleSub: 'text-white/80',
    classBadge: 'bg-white/25 backdrop-blur-sm text-white border border-white/30 font-bold',
    topicPill: 'bg-black/30 text-white/95 border border-white/15',
    subjectColor: 'text-white font-black',
    btnGrading: 'bg-emerald-600 hover:bg-emerald-500 text-white shadow-md font-black',
    btnAttendance: 'bg-indigo-600 hover:bg-indigo-500 text-white shadow-md font-black',
    statusSelect: 'bg-white/20 text-white border border-white/40 font-black backdrop-blur-sm',
    statusSelectIcon: 'text-white',
    breakCard: 'bg-gradient-to-r from-slate-950 via-purple-950 to-slate-900 border-purple-400/50 text-white shadow-lg',
    breakIcon: 'bg-white/20 text-white border border-white/30',
    sidebarBgLight: 'bg-slate-900 text-white',
    sidebarBgDark: 'bg-black text-white',
    headerBgLight: 'bg-slate-900 text-white',
    headerBgDark: 'bg-black text-white',
    appBgLight: 'bg-slate-950',
    appBgDark: 'bg-black',
  },
  {
    id: 'obsidian-gold',
    name: 'Obsidian Gold',
    shortName: 'Obsidian Gold',
    tag: 'Tema 15',
    description: 'Perpaduan mewah batu obsidian hitam legam dengan kilau emas 24k dan perunggu antik',
    badgeBg: 'bg-amber-500 text-black font-black',
    primaryColor: '#f59e0b',
    accentGradient: 'from-amber-400 via-yellow-500 to-amber-600',
    activeNavGradient: 'from-amber-500 via-yellow-500 to-amber-600',
    sidebarActive: 'bg-gradient-to-r from-amber-500 to-yellow-500 text-slate-950 font-black shadow-[0_0_15px_rgba(245,158,11,0.35)]',
    primaryButton: 'bg-amber-500 hover:bg-amber-600 text-slate-950 font-black shadow-[0_0_15px_rgba(245,158,11,0.35)]',
    cardGradients: [
      'bg-gradient-to-r from-neutral-950 via-stone-900 to-neutral-900 border-amber-400/60 text-amber-50 shadow-lg shadow-amber-950/40',
      'bg-gradient-to-r from-neutral-950 via-zinc-900 to-amber-950 border-yellow-400/60 text-yellow-50 shadow-lg shadow-yellow-950/40',
      'bg-gradient-to-r from-black via-stone-900 to-neutral-900 border-amber-400/60 text-amber-50 shadow-lg shadow-amber-950/40',
      'bg-gradient-to-r from-neutral-950 via-amber-950 to-black border-amber-500/60 text-amber-50 shadow-lg shadow-amber-950/40',
      'bg-gradient-to-r from-zinc-950 via-neutral-900 to-stone-950 border-yellow-500/60 text-yellow-50 shadow-lg shadow-yellow-950/40',
      'bg-gradient-to-r from-stone-950 via-neutral-950 to-amber-950 border-amber-400/60 text-amber-50 shadow-lg shadow-amber-950/40',
      'bg-gradient-to-r from-black via-neutral-900 to-zinc-950 border-amber-400/60 text-amber-50 shadow-lg shadow-amber-950/40',
    ],
    activeRing: 'ring-2 ring-amber-400 shadow-[0_0_20px_rgba(245,158,11,0.5)] scale-[1.01]',
    capsule: 'bg-black/80 text-amber-300 border border-amber-400/60 shadow-inner',
    capsuleSub: 'text-amber-400',
    classBadge: 'bg-amber-400/20 text-amber-300 border border-amber-400/60 font-bold',
    topicPill: 'bg-black/70 text-amber-100 border border-amber-500/40',
    subjectColor: 'text-white font-black',
    btnGrading: 'bg-emerald-600 hover:bg-emerald-500 text-white font-black shadow-md border border-emerald-400/40',
    btnAttendance: 'bg-amber-500 hover:bg-amber-400 text-slate-950 font-black shadow-md border border-amber-300',
    statusSelect: 'bg-black/80 text-amber-200 border border-amber-400/60 font-bold',
    statusSelectIcon: 'text-amber-400',
    breakCard: 'bg-gradient-to-r from-black via-stone-950 to-amber-950 border-amber-400/60 text-amber-200 shadow-lg',
    breakIcon: 'bg-amber-950/80 text-amber-300 border border-amber-400/60',
    sidebarBgLight: 'bg-neutral-950 text-amber-100 border-amber-900/40',
    sidebarBgDark: 'bg-black text-amber-100 border-amber-500/30',
    headerBgLight: 'bg-neutral-950 text-amber-100 border-amber-900/40',
    headerBgDark: 'bg-black text-amber-100 border-amber-500/30',
    appBgLight: 'bg-neutral-950',
    appBgDark: 'bg-black',
  },
];

export const getThemeById = (id: string): GlobalTheme => {
  return APP_THEMES.find(t => t.id === id) || APP_THEMES[0];
};

export const getThemeByIndex = (index: number): GlobalTheme => {
  const safeIndex = (index >= 0 && index < APP_THEMES.length) ? index : 0;
  return APP_THEMES[safeIndex];
};

export const getNextThemeId = (currentId: string): string => {
  const currentIndex = APP_THEMES.findIndex(t => t.id === currentId);
  const nextIndex = currentIndex === -1 ? 1 : (currentIndex + 1) % APP_THEMES.length;
  return APP_THEMES[nextIndex].id;
};
